import {isProd} from "@qoohoo/common/constants/isProd";
import {creator_DUMMY} from "./staging/creator_DUMMY";
import {creator_K4WJYOK1} from "./production/creator_K4WJYOK1";
import {creator_STNR3PST} from "./production/creator_STNR3PST";
import {creator_S13ITPIT} from "./production/creator_S13ITPIT";
import {creator_X2AQOJ8B} from "./production/creator_X2AQOJ8B";
import {creator_6C1LH8CH} from "./production/creator_6C1LH8CH";
import {creator_RHV61VGH} from "./production/creator_RHV61VGH";
import {creator_MQ5JRF5B} from "./production/creator_MQ5JRF5B";
import {creator_GYO4CTB4} from "./production/creator_GYO4CTB4";
import {creator_AFB959L7} from "./production/creator_AFB959L7";
import {creator_KP72BX3T} from "./production/creator_KP72BX3T";
import {creator_OMO8ZK1P} from "./production/creator_OMO8ZK1P";
import {creator_DPUDE2FI} from "./production/creator_DPUDE2FI";
import {creator_9E7JI8FP} from "./production/creator_9E7JI8FP";

const configsProduction = {
  K4WJYOK1: creator_K4WJYOK1,
  STNR3PST: creator_STNR3PST,
  S13ITPIT: creator_S13ITPIT,
  GYO4CTB4: creator_GYO4CTB4,
  X2AQOJ8B: creator_X2AQOJ8B,
  MQ5JRF5B: creator_MQ5JRF5B,
  '6C1LH8CH': creator_6C1LH8CH,
  RHV61VGH: creator_RHV61VGH,
  KP72BX3T: creator_KP72BX3T,
  OMO8ZK1P: creator_OMO8ZK1P,
  '9E7JI8FP': creator_9E7JI8FP,
  DPUDE2FI: creator_DPUDE2FI,
  AFB959L7: creator_AFB959L7
};

const configsStaging = {
  MW2F6JH1: creator_DUMMY,
};

export const getCustomCreatorConfig = (creatorId) =>  {
  if(!creatorId) {
    return null;
  }

  const config = isProd ? configsProduction[creatorId.toUpperCase()] : configsStaging[creatorId.toUpperCase()];

  return (config || null);
}
